import { flexRowCenter } from '../../../../common/styles/flex';

interface StylesObject {
  titleAndLogoStyle: { [key: string]: any };
}
const titleAndLogo = {
  ...flexRowCenter,
  alignItems: 'center',
};

export const getLogoAndTitleStyleObject = (): StylesObject => ({
  titleAndLogoStyle: {
    ...titleAndLogo,
  },
});
